import { formatProbability } from '../../utils/format'
import { tForLocale, useLocale } from '../../i18n/locale'

interface ProbabilityBarProps {
  probability: number
}

export function ProbabilityBar({ probability }: ProbabilityBarProps) {
  const { locale } = useLocale()
  const width = Math.max(0, Math.min(probability, 1)) * 100

  return (
    <div className="probability-bar" aria-label={tForLocale(locale, 'aria.probability', { value: formatProbability(probability) })}>
      <span className="probability-bar-fill" style={{ width: `${width}%` }} />
    </div>
  )
}
